import {
  ScaffolderFormHeader,
  ScaffolderFormPaper,
} from '@internal/plugin-scaffolder-common-field-react';
import React from 'react';

import { Box } from '@material-ui/core';

import { ClusterPicker } from '../components/ClusterPicker';
import { ClusterConfiguration, Cluster, DEFAULT_CLUSTER } from '../types';

interface ApplicationSetClusterSectionProps {
  value: ClusterConfiguration | null;
  availableClusters: Cluster[];
  onChange: (value: ClusterConfiguration | null) => void;
  errors: string[];
  enableAppSetSupport?: boolean;
}

const ApplicationSetClusterSectionInner = ({
  value,
  availableClusters,
  onChange,
  errors,
  enableAppSetSupport,
}: ApplicationSetClusterSectionProps) => {
  return (
    <Box>
      <ScaffolderFormPaper>
        <ScaffolderFormHeader
          title="Cluster"
          description="Select the cluster and namespace for this ApplicationSet."
          divider
        />
        <ClusterPicker
          value={value ?? DEFAULT_CLUSTER}
          clusters={availableClusters}
          onChange={onChange}
          errors={errors}
          enableAppSetSupport={enableAppSetSupport}
        />
      </ScaffolderFormPaper>
    </Box>
  );
};

export const ApplicationSetClusterSection = React.memo(
  ApplicationSetClusterSectionInner,
);
